@if (hasData()) {
  <div class="container">
    @if (hasPathData()) {
      <ldw-structure-bread-crumb
        (itemSelected)="breadcrumbSelected($event)"
        [path]="data.pathInfo"
      ></ldw-structure-bread-crumb>
    }
    <mat-selection-list [hideSingleSelectionIndicator]="true" [multiple]="false" class="virtual-scroll-list">
      <cdk-virtual-scroll-viewport
        (scrolledIndexChange)="scrolled$.next($event)"
        [itemSize]="50"
        class="virtual-scroll-viewport"
        >
        <mat-list-option
          *cdkVirtualFor="let item of data.data"
          [value]="item"
          [ldwScrollIntoView]="item.id === selectedId"
          >
          <ldw-structure-list-item
            [item]="item"
            [webDokuId]="data.webDokuId"
            [search]="search"
            (itemSelected)="internalSelection($event)"
            [disablePreview]="disablePreview"
            [showTreePath]="showTreePath"
            class="no-padding"
          ></ldw-structure-list-item>
        </mat-list-option>
        <div class="spacer-8"></div>
      </cdk-virtual-scroll-viewport>
    </mat-selection-list>
  </div>
}
@if (!hasData() && showNoData) {
  <div class="nodata-container">
    <div class="nodata">
      <p><mat-icon>do_disturb</mat-icon></p>
      <p>{{ 'STATUS.NODATA' | translate }}</p>
    </div>
  </div>
}
